export default "__VITE_ASSET__CT$3NV9K__"